import { render } from "./Templates.vue?vue&type=template&id=3a7504b2"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
script.render = render

export default script